var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeatingFacemin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 600,
    width: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.984 0 0 .984 4.8 4.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#e34552",
    r: 250,
    cy: 300,
    cx: 300
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db3845",
    d: "M124 123a237.245 268.878 0 00392 303M124 123a249.609 249.609 0 00353 353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e34552",
    d: "M124 123c1 102 176 252 392 303z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingFacemin);
export default __webpack_public_path__ + "static/media/HeatingFace.min.a76ccb249ffff1ff975a913f4dda9d68.svg";
export { ForwardRef as ReactComponent };